export class FormValidRptModel {
    isTpcLocal = false;
    isTpcSoloLLevar = false;
    isTpcSoloDelivery = false;
    isTpcSoloOther = false;
    isRequiereMesa = false;
}
